import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { ListItems } from '~/eds/src/components/ListItems/ListItems';
import { Panel } from '~/eds/src/components/Panel/Panel';
import { ListItem } from '~/eds/src/types/ListItem';
import { slices } from '~/redux/slices';

import { useGetLatestLibraryModelVersions } from '../hooks';
import { getSortedCategories } from './utils';

export const Categories = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeCategory = useSelector(
    slices.xRayLibrary.selectors.selectCategory,
  );
  const { models } = useGetLatestLibraryModelVersions({});
  const categories = getSortedCategories(models);
  const items: ListItem[] = [
    {
      title: intl.formatMessage({
        id: 'Categories.allCategories',
        defaultMessage: 'All Categories',
        description: 'Title for all categories',
      }),
      isSelected: !activeCategory,
      onClick: () => {
        dispatch(slices.xRayLibrary.actions.setCategory(null));
      },
    },
    ...categories.map((tag) => ({
      title: tag.label,
      isSelected: activeCategory === tag,
      onClick: () => {
        dispatch(slices.xRayLibrary.actions.setCategory(tag));
      },
    })),
  ];

  return (
    <Panel
      enableContentPadding={false}
      title={intl.formatMessage({
        id: 'Categories.title',
        defaultMessage: 'Categories',
        description: 'Title for categories panel',
      })}
      width="280px"
    >
      <ListItems enablePadding as="ul" items={items} />
    </Panel>
  );
};
